import actions from './actions'
import mutations from './mutations'
import getters from './getters'

let state = {
  addPartnerDialog: false,
  partnerEditDialog: false,
  totalPartners: 0,
  activePartnersIds: []
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}


// WEBPACK FOOTER //
// ./src/store/partners/index.js